import { partnerPlannerService } from 'partner/shared/services';
import { useMutation } from 'react-query';

export const usePartnerCancelShift = () => {
  const mutationFn = async ({ shiftClaimId }: { shiftClaimId: string }) =>
    await partnerPlannerService.cancelShift(shiftClaimId);

  return useMutation(mutationFn);
};
